import { useContext } from 'react';
import { ListContext } from '@contexts/ListContext';

const useLayoutConfigurations = () => {
    const { cachedList } = useContext(ListContext);
    return  cachedList.layoutConfigurations.items;
}

export default useLayoutConfigurations;
